import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { t } from '../../utils/i18n';

type IProps = {
  tripID: string;
  menu: object;
  hotels: any[];
};

const NavigationLinks: React.FC<IProps> = ({ tripID, menu, hotels }) => {
  const renderLinks = () => (menu
    ? Object.values(menu).map(menuItem => (
      <NavLink
        className="menulink"
        key={menuItem.ID}
        to={{
          pathname: `/${menuItem.slug}`,
          search: `?resa=${tripID}`,
        }}
      >
        {menuItem.title}
      </NavLink>
    ))
    : null);

  return (
    <>
      {renderLinks()}
      {hotels && hotels.length > 0 && (
        <NavLink
          className="menulink"
          to={{
            pathname: '/hotell',
            search: `?resa=${tripID}`,
          }}
        >
          {t({ sv: 'Hotell', no: 'Hotell', da: 'Hoteller', fi: 'Hotellit', en: 'Hotel' })}
        </NavLink>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  menu: state.tripPage.items.menu,
  hotels: state.tripPage.items.hotels,
});

export default connect(mapStateToProps)(NavigationLinks);
